import React from 'react'
import './inquiry-by-town.css'

const InquiryByTown = ({students}) => {
    const [towns, setTowns] = React.useState({})

    React.useEffect(() => {
        students.length > 0 && tallyAllStudentsByTown(students)
    }, [students])

    const tallyAllStudentsByTown = (students) => {
        let towns = {};
        let eachSchoolTotal = {
            MMA: {grandTotal: 0, activeTotal: 0}, 
            LSMA: {grandTotal: 0, activeTotal: 0}, 
            TMA: {grandTotal: 0, activeTotal: 0}, 
            MOR: {grandTotal: 0, activeTotal: 0}, 
            PSMA: {grandTotal: 0, activeTotal: 0}
        }
        for (let i = 0; i < students.length; i++) {
            if(students[i].school !== 'GLMA') {
                if(eachSchoolTotal[students[i].school] !== '') {
                    if(eachSchoolTotal[students[i].school]) {
                        eachSchoolTotal[students[i].school]['grandTotal'] += students[i].students.length;
                    }
                }
              if(students[i].address){
                let trimmedCity = students[i].address.city.trim().toLowerCase();
                if(trimmedCity !== '') {
                    if (towns[trimmedCity]) {
                        towns[trimmedCity].grandTotal += students[i].students.length;
                      } else {
                        towns[trimmedCity] = {
                            grandTotal: students[i].students.length,
                            school: students[i].school,
                            activeTotal: 0
                        };
                      }
                }
            }
          } 
          if(students[i].school !== 'GLMA' && students[i].familyStatus === 'Active') {
            if(eachSchoolTotal[students[i].school] !== '') {
                eachSchoolTotal[students[i].school].activeTotal += students[i].students.length;
            }
            if(students[i].address){
                let trimmedCity = students[i].address.city.trim().toLowerCase();
                if(trimmedCity !== '') {
                    if (towns[trimmedCity]) {
                        towns[trimmedCity].activeTotal += students[i].students.length;
                      }
                }
            }
          }
        }
    
        //sort the towns by number of students
        let sortable = [];
        for (let town in towns) {
          //calculate what percentage of the total students are in each town
          let percentageOfSchool = Math.round((towns[town].grandTotal / eachSchoolTotal[towns[town].school].grandTotal) * 100);
          sortable.push({townName: town, school: towns[town].school, totalInquiries: towns[town].grandTotal, inquiryPercentage: percentageOfSchool, activeTotal: towns[town].activeTotal, activePercentage: Math.round((towns[town].activeTotal / eachSchoolTotal[towns[town].school].activeTotal) * 100)});
        }
        sortable.sort(function (a, b) {
          return b[1] - a[1];
        });
        setTowns(sortSortableArrayBySchoolAndTotal(sortable));
      };

    const sortSortableArrayBySchoolAndTotal = (sortable) => {
        let sortedBySchool = {};
        for (let i = 0; i < sortable.length; i++) {
            if (sortedBySchool[sortable[i].school]) {
                sortedBySchool[sortable[i].school].push(sortable[i]);
            } else {
                sortedBySchool[sortable[i].school] = [];
                sortedBySchool[sortable[i].school].push(sortable[i]);
            }
        }
        //SORT EACH SCHOOL ARRAY BY HIGHEST PERCENTAGE
        for (let school in sortedBySchool) {
            sortedBySchool[school].sort(function (a, b) {
                return b.activePercentage - a.activePercentage;
            });
        }
        return sortedBySchool
    }

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }



    return (
        <div className='inquiry-by-town_wrapper'>
            <div className='inquiry-by-town__title'>Inquiries By Town</div>
            {Object.keys(towns).map((school) => (
                <div key={school} className='inquiry-by-town__each-school'>
                    <div className='inquiry-by-town__school-title'>{school}</div>
                    <div>
                        {towns[school].map((packet, index) => packet.activePercentage > 1 && (
                            <div key={index} className='inquiry-by-town__each-town'>
                                <div className='inquiry-by-town__each-town__title'><strong>{capitalizeFirstLetter(packet.townName)}</strong> Inquiries: {packet.totalInquiries} ({packet.inquiryPercentage}%) | Active Students: {packet.activeTotal} ({packet.activePercentage}%)</div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}
export default InquiryByTown;